module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/photo-chapel-og-image-fdc4c44ecbd8c74efdea5e175acda526.png";